import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { user, login, ready } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Giriş başarılı");
      window.location.href = "/";
    } catch (err) {
      toast.error(err.response?.data?.detail || "Giriş başarısız");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex bg-background">
      <div className="hidden lg:flex flex-1 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-primary/20" />
        <div className="relative z-10 flex flex-col justify-between p-12 text-white w-full">
          <div />
          <div className="flex items-center justify-center">
            <img src="https://customer-assets-v7afamib.emergentagent.net/job_demir-finans/artifacts/o8x43ruo_IMG_20220611_144831_918.png"
              alt="Badem Ticaret" className="w-full max-w-md h-auto object-contain invert drop-shadow-2xl" data-testid="login-logo" />
          </div>
          <div className="text-xs text-white/40">© 2026 Badem Ticaret</div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <Card className="w-full max-w-md p-8 border-border">
          <h2 className="text-2xl font-bold mb-1">Giriş Yap</h2>
          <p className="text-sm text-muted-foreground mb-6">Hesabınıza giriş yapın</p>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">E-posta</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                required data-testid="login-email-input" className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Şifre</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required data-testid="login-password-input" className="mt-1.5" />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11" data-testid="login-submit-btn">
              {loading ? <Loader2 className="animate-spin" size={18} /> : "Giriş Yap"}
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
